import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { useDynamicMenu } from 'hooks/useDynamicMenu';
import { DASHBOARD_PATH } from 'config';
import { GuardProps } from 'types';
import { resolveUserRole } from 'utils/resolveUserRole';
import { FORM_ROLE } from 'utils/createFormRolePolicy';
import { findFirstMenuUrl } from 'utils/menuTransformer';
import { useEffect } from 'react';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn, user } = useAuth();
  const isAdmin = resolveUserRole(user) === FORM_ROLE.ADMIN;
  // Dashboard is Admin-only for now — everyone else lands on their first menu item instead.
  const { menuItems, isLoading: isMenuLoading } = useDynamicMenu();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) return;
    if (!isAdmin) {
      if (isMenuLoading) return; // wait for the menu so we know where to land
      navigate(findFirstMenuUrl(menuItems) ?? DASHBOARD_PATH, { replace: true });
      return;
    }
    navigate(DASHBOARD_PATH, { replace: true });
  }, [isLoggedIn, isAdmin, isMenuLoading, menuItems, navigate]);

  return children;
}
